module.exports = __webpack_public_path__ + "static/P2101537-75bb254da754a63752ffb006ebfc2913.jpg";